export class Slide{
    constructor(
        public url:string,
        public _id?:any,
        public caption?:string,
        public title?:string
    ){}
}